// useProducts — the per-company product catalog (GET /v1/companies/:id/products).
import { useQuery } from "@tanstack/react-query";

import { listProducts, type ListProductsParams } from "@/api/products";
import { useAuth } from "@/store/auth";

export function useProducts(
  companyId: string | undefined,
  params: ListProductsParams = {},
) {
  const status = useAuth((s) => s.status);
  return useQuery({
    queryKey: ["products", companyId, params],
    queryFn: () => listProducts(companyId!, params),
    enabled: status === "authenticated" && companyId != null && companyId !== "",
    staleTime: 60_000,
  });
}
